module.exports = __webpack_public_path__ + "static/media/small.f0384ac6.png";